import { useMutation } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

export async function exportPortfolioFullPolicies(
  orgId: string,
  accreditationBodyId: string,
  accreditationBodyVersionId: string
): Promise<void> {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/organizations/${orgId}/portfolio-assessments/full-policies/${accreditationBodyId}/${accreditationBodyVersionId}`;

  await fetcher({
    method: 'post',
    url,
  });
}

export default function usePortfolioExportFullPolicies(
  onSuccess?: () => void,
  onError?: (error: ServerErrorResponse) => void
) {
  return useMutation<
    void,
    ServerErrorResponse,
    {
      orgId: string;
      accreditationBodyId: string;
      accreditationBodyVersionId: string;
    }
  >(
    ({ orgId, accreditationBodyId, accreditationBodyVersionId }) =>
      exportPortfolioFullPolicies(orgId, accreditationBodyId, accreditationBodyVersionId),
    {
      onSuccess,
      onError,
    }
  );
}
